"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginFormFields = exports.LoginCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const theme_1 = require("./theme");
const Input_1 = require("./Input");
const Button_1 = __importDefault(require("./Button"));
/** Full-screen gradient + card layout. Use for mango-shop, mango-calendar, mango-feed, mango-chat Login. */
const LoginCard = ({ title, subtitle, error, children }) => ((0, jsx_runtime_1.jsx)("div", { style: {
        minHeight: '100vh',
        background: theme_1.theme.colors.primaryGradient,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
    }, children: (0, jsx_runtime_1.jsxs)("div", { style: {
            background: theme_1.theme.colors.card,
            padding: theme_1.theme.spacing.cardPadding,
            borderRadius: theme_1.theme.radii.card,
            width: '100%',
            maxWidth: 400,
            boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
        }, children: [(0, jsx_runtime_1.jsxs)("div", { style: { textAlign: 'center', marginBottom: 28 }, children: [(0, jsx_runtime_1.jsx)("span", { style: { fontSize: 48 }, children: "\uD83E\uDD6D" }), (0, jsx_runtime_1.jsx)("h1", { style: { margin: '12px 0 6px', fontSize: 24, color: theme_1.theme.colors.text }, children: title }), subtitle && ((0, jsx_runtime_1.jsx)("p", { style: { margin: 0, color: theme_1.theme.colors.textMuted, fontSize: 14 }, children: subtitle }))] }), error && ((0, jsx_runtime_1.jsx)("div", { style: {
                    padding: 12,
                    background: theme_1.theme.colors.errorBg,
                    color: theme_1.theme.colors.errorText,
                    borderRadius: theme_1.theme.radii.error,
                    marginBottom: 20,
                    fontSize: 14,
                }, children: error })), children] }) }));
exports.LoginCard = LoginCard;
/** Email + password form fields + submit button using shared theme. */
const LoginFormFields = ({ email, setEmail, password, setPassword, loading, onSubmit, submitLabel = 'Sign in', loadingLabel = 'Signing in...', }) => ((0, jsx_runtime_1.jsxs)("form", { onSubmit: onSubmit, children: [(0, jsx_runtime_1.jsx)(Input_1.Input, { type: "email", value: email, onChange: (e) => setEmail(e.target.value), placeholder: "Email", required: true }), (0, jsx_runtime_1.jsx)(Input_1.Input, { type: "password", value: password, onChange: (e) => setPassword(e.target.value), placeholder: "Password", required: true, style: { marginBottom: 20 } }), (0, jsx_runtime_1.jsx)(Button_1.default, { type: "submit", fullWidth: true, loading: loading, style: { marginBottom: 0 }, children: loading ? loadingLabel : submitLabel })] }));
exports.LoginFormFields = LoginFormFields;
